export default __webpack_public_path__ + "static/media/arrow_down_ckb.499c80d9.svg";